var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAlert)?_c('div',{staticClass:"error-text"},_vm._l((_vm.errorStatements),function(error,index){return _c('ul',{key:index,staticClass:"mb-0",class:{
      'list-unstyled': _vm.errorStatements.length === 1,
      multiline: _vm.errorStatements.length > 1,
    }},[_c('li',[_vm._v(_vm._s(error))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }